import { useState, createContext} from "react";


interface App{}
interface setMove {
number:number
}


const AppCtx = createContext<App| any>(null);

const Context=(props:any)=> {
    const [yPosition, setPositionY] = useState<number>(0)


  const Categories:{name:string, img:string}[]  = [
    {
      name: "Proteinas",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      
    },
    {
      name: "Barras de proteina",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",


      
    },
    {
      name: "Creatinas",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",


    },
    {
      name: "Glutamina",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",


    },
    {
      name: "Carnitina",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",


    },
    {
        name:"aminoacidos",
        img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",

    }
  ];

  const products:{name:string, img:string, price:number}[]  = [
    {
      name: "Whey protein",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      price: 899
    },
    {
      name: "Muscle Protein",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      price: 899

      
    },
    {
      name: "Domain",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      price: 899

    },
    {
      name: "Glutamina",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      price: 899

    },
    {
      name: "Carnitina",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      price: 899

    },
    {
        name:"aminoacidos",
        img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",     
        price: 899

    } ,
    {
      name: "Glutamina",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      price: 899

    },
    {
      name: "Carnitina",
      img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
      price: 899

    },
    {
        name:"aminoacidos",
        img:"https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png",
        price: 899

    }
  ];
  

  return <AppCtx.Provider value={{Categories,setPositionY,yPosition,products}}>{props.children}</AppCtx.Provider>;
}

const exportContext = {
  AppCtx,
  Context,
};

export default exportContext;
